/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type stands_new_QueryVariables = {};
export type stands_new_QueryResponse = {
    readonly currentMetaData: {
        readonly year: number | null;
        readonly startDate: string;
        readonly endDate: string;
    };
};
export type stands_new_Query = {
    readonly response: stands_new_QueryResponse;
    readonly variables: stands_new_QueryVariables;
};



/*
query stands_new_Query {
  currentMetaData {
    year
    startDate
    endDate
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "stands_new_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MetaData",
        "kind": "LinkedField",
        "name": "currentMetaData",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "stands_new_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MetaData",
        "kind": "LinkedField",
        "name": "currentMetaData",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6cd40a4ae0bac98d7a5cdffb3596cb8a",
    "id": null,
    "metadata": {},
    "name": "stands_new_Query",
    "operationKind": "query",
    "text": "query stands_new_Query {\n  currentMetaData {\n    year\n    startDate\n    endDate\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '4118d2d7e3d156cf1aebac0bbde4b463';
export default node;
